import 'babel-polyfill'
import Vue from 'vue'
import vuetify from './plugins/vuetify';
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App.vue'
import VueMeta from 'vue-meta'
import VueScrollTo from 'vue-scrollto'
import vueSmoothScroll from 'vue2-smooth-scroll'

import { Ripple } from 'vuetify/lib/directives'
import vueHeadful from 'vue-headful';

Vue.component('vue-headful', vueHeadful);
Vue.use(VueMeta);
Vue.use(VueAxios, axios);
Vue.use(router);
Vue.use(VueScrollTo);
Vue.use(vueSmoothScroll)
Vue.use(vuetify, {
  directives: {
    Ripple
  }
})

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  axios,
  render: h => h(App)
}).$mount('#app')
